import { doRequest } from '../requests/actions';

export const actions = {
  SET: 'SHIFT_DETAILS_SET',
};

export function set(details) {
  return {
    type: actions.SET,
    value: details,
  };
}

/**
 * Refresh this accounts shift details
 */
export function get() {
  return async (dispatch) => {
    const details = await dispatch(doRequest({ endpoint: '/shift_details' }));
    if (details) {
      dispatch(set(details));
    }
  };
}

/**
 * Thin wrapper around #get to refresh the shift details
 * @returns {function(*): *}
 */
export function refresh() {
  return (dispatch) => {
    dispatch(get());
  };
}



// WEBPACK FOOTER //
// ./src/store/shiftDetails/actions.js